import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, input, OnInit } from '@angular/core';

import { BaseComponent } from '../../../core/abstractions/base.component';
import { TranslationLanguageModel } from '../../../models/translation-language.model';
import { TranslationService } from '../../../services/translation.service';

@Component({
    selector: 'sl-language-switcher',
    templateUrl: './language-switcher.component.html',
    styleUrls: ['./language-switcher.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LanguageSwitcherComponent extends BaseComponent implements OnInit {
    showText = input(true);

    selectedLanguage: TranslationLanguageModel;
    allowedLanguages: TranslationLanguageModel[] = [];

    private readonly translationService = inject(TranslationService);
    private readonly changeDetectorRef = inject(ChangeDetectorRef);

    constructor() {
        super();
        this.selectedLanguage = this.translationService.getCurrent();
    }

    ngOnInit(): void {
        this.allowedLanguages = [...this.translationService.allowedLanguages];

        if (this.allowedLanguages.length < 1) {
            const langsLoadedSub = this.translationService.setupCompletedSub.subscribe(() => {
                this.allowedLanguages = [...this.translationService.allowedLanguages];
                this.selectedLanguage = this.translationService.getCurrent();
                this.changeDetectorRef.detectChanges();
            });

            this.addSubscriptions(langsLoadedSub);
        }
    }

    switchLanguage(code: string): void {
        this.translationService.switch(code);
        this.selectedLanguage = this.translationService.getCurrent();
    }
}
